import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const GlobalSearchContext = createContext();

export const useGlobalSearch = () => useContext(GlobalSearchContext);

export const GlobalSearchProvider = ({ children }) => {
  const [globalSearch, setGlobalSearch] = useState("");
  const location = useLocation();

  const value = {
    globalSearch,
    setGlobalSearch,
  };

  useEffect(() => {
    setGlobalSearch("");
  }, [location.pathname]);

  return (
    <GlobalSearchContext.Provider value={value}>
      {children}
    </GlobalSearchContext.Provider>
  );
};
